import Dialog from './dialog'
import Typography from '../../atoms/typography'
import Button from '../button'
import IconBadge from '../icon-badge'
import Icon from '../../atoms/icon/icon'
import { Title, Description, Actions } from './dialog-text.styled'
import { useTheme } from '@mui/system'
import useMediaQuery from '@mui/material/useMediaQuery'
import { shape, string, elementType, object, oneOfType, node } from 'prop-types'

const DialogText = ({
	Icon,
	iconProps,
	variant,
	boxStyle,
	title,
	titleProps,
	description,
	descriptionProps,
	actions,
	...props
}) => {
	const theme = useTheme()
	const smUp = useMediaQuery(theme.breakpoints.up('sm'))

	const paperProps = {
		sx: {
			gridTemplateRows: Icon ? (variant === 'lg' ? '146px 0fr 0fr' : '106px 0fr 0fr') : '',
			padding: Icon ? (smUp ? (props.variant === 'lg' ? '100px 140px' : '82px 120px') : '') : '',
		},
	}

	const boxIconStyle = {
		...boxStyle,
		mb: variant === 'lg' ? '40px' : '30px',
	}

	return (
		<Dialog PaperProps={paperProps} maxWidth={smUp ? variant : 'sm'} {...props}>
			{Icon && <IconBadge Icon={Icon} iconProps={iconProps} size={variant} boxStyle={boxIconStyle} />}
			{title && (
				<Title
					component="h2"
					color="primary"
					align="center"
					variant={!smUp ? 'h3' : variant === 'lg' ? 'h1' : 'h2'}
					dialogVariant={variant}
					{...titleProps}
				>
					{title}
				</Title>
			)}
			{description && (
				<Description variant="body1" color="grey.main" align="center" {...descriptionProps}>
					{description}
				</Description>
			)}
			{actions?.length > 0 && (
				<Actions dialogVariant={variant}>
					{actions.map((actionProp, i) => (
						<Button key={i} {...actionProp} />
					))}
				</Actions>
			)}
		</Dialog>
	)
}

DialogText.defaultProps = {
	...Dialog.defaultProps,
}

DialogText.propTypes = {
	...Dialog.propTypes,
	Icon: elementType,
	iconProps: shape({ ...Icon.propTypes }),
	size: string,
	boxStyle: object,
	title: oneOfType([string, node]),
	titleProps: shape(Typography.propTypes),
	description: oneOfType([string, node]),
	descriptionProps: shape(Typography.propTypes),
}

export default DialogText
